import { useState } from "react";
import { toast } from "sonner";
import { MessageSquareText, Send, Loader2, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { api, errMsg } from "@/lib/api";
import { STATUS, PROGRAM_LABEL } from "@/lib/constants";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

const EXAMPLES = ["Berapa siswa SSW dari Jawa Barat yang lulus wawancara bulan ini?", "Job order apa saja yang wawancaranya 2 minggu ke depan?", "Berapa siswa per vendor yang masih terdaftar?"];

export const AskData = () => {
  const [q, setQ] = useState("");
  const [busy, setBusy] = useState(false);
  const [res, setRes] = useState(null);
  const ask = async (question) => {
    const text = (question || q).trim();
    if (!text) return;
    setQ(text); setBusy(true); setRes(null);
    try { const r = await api.post("/ai/ask", { question: text }); setRes(r.data); } catch (ex) { toast.error(errMsg(ex)); } finally { setBusy(false); }
  };
  return (
    <div className="surface p-5 rise" data-testid="ask-data">
      <p className="eyebrow flex items-center gap-1 mb-3"><MessageSquareText className="h-3.5 w-3.5" />Tanya Data</p>
      <form className="flex gap-2" onSubmit={(e) => { e.preventDefault(); ask(); }}>
        <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Tanya dengan bahasa biasa, mis. berapa siswa SSW Jawa Barat lulus wawancara bulan ini?" data-testid="ask-input" />
        <Button type="submit" disabled={busy || !q.trim()} data-testid="ask-submit">{busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Send className="h-4 w-4" />}</Button>
      </form>
      {!res && !busy && <div className="flex flex-wrap gap-1.5 mt-2">{EXAMPLES.map((e) => <button key={e} type="button" onClick={() => ask(e)} className="text-[11px] rounded-full border border-border px-2.5 py-1 hover:bg-muted" data-testid="ask-example">{e}</button>)}</div>}
      {res && <div className="mt-3 space-y-2 text-sm">
        <p className="font-medium" data-testid="ask-answer">{res.answer}</p>
        {res.link && res.count > 0 && <Link to={res.link.to} className="inline-flex items-center gap-1 text-xs font-semibold text-primary hover:underline" data-testid="ask-link">{res.link.label} ({res.count})<ArrowRight className="h-3 w-3" /></Link>}
        {res.groups?.length > 0 && <ul className="text-xs grid sm:grid-cols-2 gap-x-4" data-testid="ask-groups">{res.groups.map((g, i) => <li key={i} className="flex justify-between border-b border-border/60 py-0.5"><span>{STATUS[g.key]?.label || PROGRAM_LABEL(g.key) || String(g.key ?? "-")}</span><b>{g.count}</b></li>)}</ul>}
        {res.rows?.length > 0 && <details className="text-xs"><summary className="cursor-pointer text-muted-foreground">Lihat {res.rows.length} data{res.count > res.rows.length ? ` dari ${res.count}` : ""}</summary><ul className="mt-1 space-y-0.5 max-h-40 overflow-y-auto" data-testid="ask-rows">{res.rows.map((r, i) => <li key={i} className="font-mono">{r.yutaka_id || r.code} · {r.name || r.title}{r.status ? ` · ${STATUS[r.status]?.label || r.status}` : ""}</li>)}</ul></details>}
      </div>}
    </div>
  );
};
